<template>
<process></process>
</template>

<script>
import Process from './process'
export default {
  components:{
    Process
  }
}
</script>

<style>

</style>